import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';

import { Portal } from 'components';
import ui from 'modules/ui';
import UserDevice from 'services/user-device';
import OddButton from '../OddButton';
import useOddButtonWithHistory from './useOddButtonWithHistory';

const {
    components: { OddHistory },
} = ui;

interface Props {
    oddId: string;
}

const OddButtonWithHistory: React.FC<Props> = ({ oddId }) => {
    const {
        isActive,
        showHistory,
        onMouseEnter,
        onMouseLeave,
    } = useOddButtonWithHistory({
        oddId,
    });

    if (!isActive || UserDevice.getInstance()?.isDeviceMobile())
        return <OddButton oddId={oddId} />;

    return (
        <Manager>
            <Reference>
                {({ ref }) => (
                    <OddButton
                        ref={ref}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        oddId={oddId}
                    />
                )}
            </Reference>
            {showHistory && (
                <Portal isPageDisabled={false}>
                    <Popper
                        modifiers={{ arrow: { enabled: true } }}
                        placement="top"
                    >
                        {({ ref, style, arrowProps, placement }) => (
                            <OddHistory
                                oddId={oddId}
                                fRef={ref}
                                style={style}
                                arrowProps={arrowProps}
                                placement={placement}
                            />
                        )}
                    </Popper>
                </Portal>
            )}
        </Manager>
    );
};

export default React.memo(OddButtonWithHistory);
